'use client'
import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {Col, Container, Row} from 'react-bootstrap';
import {gsap} from 'gsap';
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {clearAllBodyScrollLocks} from "body-scroll-lock";
import Link from "next/link";
import {darkBrown, hover, Transition, white} from "@/styles/globalStyleVars";
import SvgButton from "@/components/SvgButton";
import {usePathname, useRouter} from "next/navigation";

const menuIconW=`<svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 0.499451C1 0.499451 4.58 0.499451 9 0.499451C13.42 0.499451 17 0.499451 17 0.499451" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1 7.49945C1 7.49945 4.58 7.49945 9 7.49945C13.42 7.49945 17 7.49945 17 7.49945" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1 14.4995C1 14.4995 4.58 14.4995 9 14.4995C13.42 14.4995 17 14.4995 17 14.4995" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
const menuIconB=`<svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 0.499451C1 0.499451 4.58 0.499451 9 0.499451C13.42 0.499451 17 0.499451 17 0.499451" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1 7.49945C1 7.49945 4.58 7.49945 9 7.49945C13.42 7.49945 17 7.49945 17 7.49945" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1 14.4995C1 14.4995 4.58 14.4995 9 14.4995C13.42 14.4995 17 14.4995 17 14.4995" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
const demo=`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.11812 12C6.07838 12 6.03865 12 5.99864 11.9998C5.05803 12.0021 4.18891 11.9782 3.3437 11.9268C2.56879 11.8796 1.86146 11.6118 1.29804 11.1524C0.754396 10.7091 0.383149 10.1097 0.194642 9.37106C0.0305787 8.72799 0.0218812 8.09673 0.0135498 7.48616C0.00750733 7.04808 0.00128174 6.52898 0 6.00108C0.00128174 5.47099 0.00750733 4.95188 0.0135498 4.5138C0.0218812 3.90333 0.0305787 3.27207 0.194642 2.62891C0.383149 1.89026 0.754396 1.29086 1.29804 0.847564C1.86146 0.388151 2.56879 0.120359 3.34379 0.0732087C4.18901 0.0218475 5.0583 -0.00213939 6.00093 0.000149441C6.94182 -0.00186473 7.81066 0.0218475 8.65588 0.0732087C9.43078 0.120359 10.1381 0.388151 10.7015 0.847564C11.2453 1.29086 11.6164 1.89026 11.8049 2.62891C11.969 3.27198 11.9777 3.90333 11.986 4.5138C11.9921 4.95188 11.9984 5.47099 11.9996 5.99888V6.00108C11.9984 6.52898 11.9921 7.04808 11.986 7.48616C11.9777 8.09664 11.9691 8.7279 11.8049 9.37106C11.6164 10.1097 11.2453 10.7091 10.7015 11.1524C10.1381 11.6118 9.43078 11.8796 8.65588 11.9268C7.84646 11.976 7.01497 12 6.11812 12ZM5.99864 11.0623C6.92397 11.0645 7.77358 11.0412 8.59893 10.991C9.18487 10.9554 9.6929 10.7652 10.1091 10.4258C10.4938 10.1121 10.7588 9.67922 10.8965 9.13924C11.0331 8.60393 11.041 8.02916 11.0486 7.47335C11.0546 7.03819 11.0608 6.52275 11.0621 5.99998C11.0608 5.47712 11.0546 4.96177 11.0486 4.52662C11.041 3.9708 11.0331 3.39603 10.8965 2.86063C10.7588 2.32065 10.4938 1.88779 10.1091 1.57404C9.6929 1.23474 9.18487 1.04459 8.59893 1.00897C7.77358 0.958709 6.92397 0.935546 6.00084 0.93756C5.0757 0.935363 4.22599 0.958709 3.40064 1.00897C2.8147 1.04459 2.30668 1.23474 1.89048 1.57404C1.50577 1.88779 1.24082 2.32065 1.10303 2.86063C0.966433 3.39603 0.95856 3.97071 0.950961 4.52662C0.94501 4.96214 0.938784 5.47786 0.937502 6.00108C0.938784 6.52202 0.94501 7.03783 0.950961 7.47335C0.95856 8.02916 0.966433 8.60393 1.10303 9.13924C1.24082 9.67922 1.50577 10.1121 1.89048 10.4258C2.30668 10.7651 2.8147 10.9553 3.40064 10.9909C4.22599 11.0412 5.07588 11.0646 5.99864 11.0623ZM5.9763 8.92968C4.36094 8.92968 3.04661 7.61544 3.04661 5.99998C3.04661 4.38453 4.36094 3.07029 5.9763 3.07029C7.59176 3.07029 8.906 4.38453 8.906 5.99998C8.906 7.61544 7.59176 8.92968 5.9763 8.92968ZM5.9763 4.00779C4.87785 4.00779 3.98411 4.90153 3.98411 5.99998C3.98411 7.09844 4.87785 7.99218 5.9763 7.99218C7.07485 7.99218 7.9685 7.09844 7.9685 5.99998C7.9685 4.90153 7.07485 4.00779 5.9763 4.00779ZM9.23412 2.13278C8.84585 2.13278 8.531 2.44754 8.531 2.83591C8.531 3.22428 8.84585 3.53904 9.23412 3.53904C9.62249 3.53904 9.93725 3.22428 9.93725 2.83591C9.93725 2.44754 9.62249 2.13278 9.23412 2.13278Z" fill="white"/>
</svg>`
const fb=`<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.04494 12V6.52664H5.88138L6.1569 4.39294H4.04494V3.03088C4.04494 2.41332 4.21573 1.99246 5.10231 1.99246L6.23124 1.99199V0.083538C6.03601 0.0581672 5.36585 0 4.58585 0C2.95709 0 1.84201 0.994179 1.84201 2.81956V4.39294H0V6.52664H1.84201V12H4.04494Z" fill="white"/>
</svg>
`
const ln=`
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.45525 0C0.575317 0 0 0.577807 0 1.33725C0 2.07993 0.558178 2.67421 1.42148 2.67421H1.43818C2.33532 2.67421 2.89365 2.07993 2.89365 1.33725C2.87688 0.577807 2.33532 0 1.45525 0ZM0.151944 3.73056H2.72435V11.4698H0.151944V3.73056ZM6.72032 4.85332C6.72032 4.85332 7.65086 3.54932 9.03858 3.54932C10.7309 3.54932 12 4.65549 12 7.03264V11.4702H9.42786V7.32993C9.42786 6.28952 9.05557 5.57981 8.12474 5.57981C7.41407 5.57981 6.99088 6.05844 6.80491 6.52045C6.73695 6.68591 6.72017 6.91691 6.72017 7.14828V11.4702H4.14784V3.73096H6.72032V4.85332Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.45525 0C0.575317 0 0 0.577807 0 1.33725C0 2.07993 0.558178 2.67421 1.42148 2.67421H1.43818C2.33532 2.67421 2.89365 2.07993 2.89365 1.33725C2.87688 0.577807 2.33532 0 1.45525 0ZM0.151944 3.73056H2.72435V11.4698H0.151944V3.73056ZM6.72032 4.85332C6.72032 4.85332 7.65086 3.54932 9.03858 3.54932C10.7309 3.54932 12 4.65549 12 7.03264V11.4702H9.42786V7.32993C9.42786 6.28952 9.05557 5.57981 8.12474 5.57981C7.41407 5.57981 6.99088 6.05844 6.80491 6.52045C6.73695 6.68591 6.72017 6.91691 6.72017 7.14828V11.4702H4.14784V3.73096H6.72032V4.85332Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.45525 0C0.575317 0 0 0.577807 0 1.33725C0 2.07993 0.558178 2.67421 1.42148 2.67421H1.43818C2.33532 2.67421 2.89365 2.07993 2.89365 1.33725C2.87688 0.577807 2.33532 0 1.45525 0ZM0.151944 3.73056H2.72435V11.4698H0.151944V3.73056ZM6.72032 4.85332C6.72032 4.85332 7.65086 3.54932 9.03858 3.54932C10.7309 3.54932 12 4.65549 12 7.03264V11.4702H9.42786V7.32993C9.42786 6.28952 9.05557 5.57981 8.12474 5.57981C7.41407 5.57981 6.99088 6.05844 6.80491 6.52045C6.73695 6.68591 6.72017 6.91691 6.72017 7.14828V11.4702H4.14784V3.73096H6.72032V4.85332Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.45525 0C0.575317 0 0 0.577807 0 1.33725C0 2.07993 0.558178 2.67421 1.42148 2.67421H1.43818C2.33532 2.67421 2.89365 2.07993 2.89365 1.33725C2.87688 0.577807 2.33532 0 1.45525 0ZM0.151944 3.73056H2.72435V11.4698H0.151944V3.73056ZM6.72032 4.85332C6.72032 4.85332 7.65086 3.54932 9.03858 3.54932C10.7309 3.54932 12 4.65549 12 7.03264V11.4702H9.42786V7.32993C9.42786 6.28952 9.05557 5.57981 8.12474 5.57981C7.41407 5.57981 6.99088 6.05844 6.80491 6.52045C6.73695 6.68591 6.72017 6.91691 6.72017 7.14828V11.4702H4.14784V3.73096H6.72032V4.85332Z" fill="white"/>
</svg>
    `
const youtube=`<svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.7528 1.3147C11.6145 0.800612 11.2092 0.395362 10.6951 0.256934C9.7561 0 5.99987 0 5.99987 0C5.99987 0 2.24378 0 1.30474 0.247193C0.800612 0.385474 0.385401 0.800685 0.24712 1.3147C0 2.25367 0 4.20096 0 4.20096C0 4.20096 0 6.15807 0.24712 7.08722C0.385548 7.60124 0.790724 8.00649 1.30481 8.14491C2.25367 8.40192 6.00001 8.40192 6.00001 8.40192C6.00001 8.40192 9.7561 8.40192 10.6951 8.15473C11.2092 8.01637 11.6145 7.61112 11.7529 7.09711C11.9999 6.15807 11.9999 4.21085 11.9999 4.21085C11.9999 4.21085 12.0098 2.25367 11.7528 1.3147ZM4.80396 5.99994V2.40198L7.92746 4.20096L4.80396 5.99994Z" fill="white"/>
</svg>
`
const twitter=`
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.98807 5.08118L11.3593 0H10.3234L6.52792 4.41192L3.49645 0H0L4.58418 6.6716L0 12H1.0359L5.04407 7.34086L8.24552 12H11.742L6.98781 5.08118H6.98807ZM5.56927 6.73038L5.10479 6.06604L1.40914 0.779804H3.00022L5.98265 5.04596L6.44712 5.71031L10.3239 11.2557H8.73286L5.56927 6.73063V6.73038Z" fill="white"/>
</svg>
    `

const DesktopMenu = ({color, isProjectPage, isLandowner}) => {


    const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
    const [hoveredColumnIndex, setHoveredColumnIndex] = useState(null);


    // Animation for menu
    const menuRef = useRef(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuTimeline, setMenuTimeline] = useState(null);


    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'visible';
        }
    }, [menuOpen]);


    const handleCloseClick2 = () => {
        setMenuOpen(false);
        gsap.to(menuRef.current, {
            opacity: 0,
            height: 0,
            duration: 1.5,
            ease: 'power2.out',
            onComplete: () => {
                gsap.set(menuRef.current, {height: 'auto', opacity: '1'});
                ScrollTrigger.refresh();
            },
        });

        const target = document.querySelectorAll('.Mobile-menu-wrap');
    };

    const handleCloseClick = () => {
        if (menuTimeline) {
            menuTimeline.reverse().then(() => {
                setMenuOpen(false);
                gsap.set(menuRef.current, {transform: 'translateY(-100vh)'});
            });
            setMenuTimeline(null);
        }
        const target = document.querySelectorAll('.Mobile-menu-wrap');
    };

    const handleMenuClick = () => {
        if (!menuOpen) {
            const timeline = gsap.timeline({paused: true});
            gsap.set(menuRef.current, {clearProps: 'all'}); // Clear previous transformations
            timeline.from(menuRef.current, {
                opacity: 'auto',
                transform: 'translateY(-100vh)',
                duration: 0.8,
                ease: 'Power3.easeOut',
                onComplete: () => {
                    gsap.set(menuRef.current, {transform: 'translateY(0)'});
                },
            });
            timeline.to('.menu-top-handle', {
                opacity: '1'
            })
            setMenuTimeline(timeline);
            setMenuOpen(true);
            timeline.play();
        }
    };





    // sticky menu fixed
    const targetElementRef = useRef(null);
    useEffect(() => {

        targetElementRef.current = document.querySelector('.show');

        return () => {

            clearAllBodyScrollLocks();
        };
    }, []);


    const [scrollUp, setScrollUp] = useState(false);
    const [scrollDown, setScrollDown] = useState(false);


    // menu fixed on scroll
    useEffect(() => {
        if (document.body.classList.contains('scroll-down')) {
            document.body.classList.remove('scroll-down');
        }
    });
    useEffect(() => {
        const body = document.body;
        const scrollUp = 'scroll-up';
        const scrollDown = 'scroll-down';
        let lastScroll = 0;
        let howMuchScroll;

        if (window.screen.width < 991) {
            howMuchScroll = 150;
        } else {
            howMuchScroll = 150;
        }

        window.addEventListener('scroll', () => {
            let currentScroll = window.pageYOffset;
            if (currentScroll <= howMuchScroll) {
                body.classList.remove(scrollUp);
                body.classList.remove(scrollDown);
                return;
            }

            if (currentScroll > lastScroll && currentScroll > howMuchScroll) {
                // down
                body.classList.remove(scrollUp);
                body.classList.add(scrollDown);
            } else if (currentScroll < lastScroll && currentScroll > howMuchScroll) {
                // up
                body.classList.remove(scrollDown);
                body.classList.add(scrollUp);
            }

            lastScroll = currentScroll;
        });
    }, []);

    const router = useRouter();
    const handleClick = () => {
        router.push('#section-id'); // replace 'section-id' with your target section ID
    };
    const pathName = usePathname();


    const handleScrollClick = (hash) => {
        if (hash) {
            setTimeout(() => {
                gsap.to(window, {duration: 0.7, scrollTo: hash});
                ScrollTrigger.refresh();
            }, 300); // Adding a slight delay
        }
    };



    return (
        <>
            <StyledPopup className={menuOpen ? 'show' : ''} ref={menuRef} >

                <Container>
                    <Row>
                        <Col>
                            <div className={'menu-top'}>
                                <div className="logo">
                                    <Link href={'/'} prefetch={true} onClick={handleCloseClick2}>
                                        <img height={80} width={112} src={'/images/static/logo_white.svg'} alt={'Unimass Property Solution'}/>
                                    </Link>
                                </div>
                                <div className={'menu-top-handle'} >
                                    <div className={'menu-top__right'} onClick={handleCloseClick}>
                                        <SvgButton svg={`<svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8536 12.6459C12.6583 12.4506 12.3417 12.4506 12.1464 12.6459C11.9512 12.8412 11.9512 13.1577 12.1464 13.353L19.2947 20.5013L12.1464 27.6496C11.9512 27.8448 11.9512 28.1614 12.1464 28.3567C12.3417 28.5519 12.6583 28.5519 12.8536 28.3567L20.0018 21.2084L27.1501 28.3567C27.3454 28.5519 27.662 28.5519 27.8572 28.3567C28.0525 28.1614 28.0525 27.8448 27.8572 27.6496L20.7089 20.5013L27.8572 13.353C28.0525 13.1577 28.0525 12.8412 27.8572 12.6459C27.662 12.4506 27.3454 12.4506 27.1501 12.6459L20.0018 19.7942L12.8536 12.6459Z" fill="white"/>
                                        </svg>`}
                                                   borderColor={`${white}`}
                                                   width={40}
                                                   height={40}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className={`menu-body ${hoveredRowIndex === 0 ? 'row-hovered' : ''}`}>
                        <Col className={`first `}
                        >
                            <div className={`menu__title-first ${hoveredColumnIndex === 0 ? 'column-hovered' : ''}`}
                            >
                                <h4>About Us</h4>
                                <ul>

                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/about#who_we_are'}>Who We Are</Link></li>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/about#bod'}>Board of Director</Link></li>
                                </ul>
                            </div>
                        </Col>

                        <Col className={`second `}>
                            <div className={`menu__title-second ${hoveredColumnIndex === 1 ? 'column-hovered' : ''}`}>
                                <h4 className={'second-menu'}>Property Solutions</h4>
                                <ul className={'grid-list'}>

                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/project?category=rent'}>Rent</Link>
                                    </li>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/project?category=buy'}>Buy</Link>
                                    </li>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/project?type=residential'}>Residential</Link></li>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/project?type=commercial'}>Commercial</Link></li>

                                </ul>
                            </div>
                        </Col>
                        <Col className={`third `}>
                            <div className={`menu__title-third ${hoveredColumnIndex === 2 ? 'column-hovered' : ''}`}>
                                <h4 className={'third-menu'}>Service</h4>

                                <ul>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/service/interior-solutions'}>Interior Solutions</Link></li>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/service/re-sale-of-property'}>Re-Sale of Property</Link></li>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/service/renovations-and-modification'}>Renovations & Modifications</Link></li>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/service/legal-logistics-services'}>Legal and Logistics Services</Link></li>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/service/design-consultancy-serives'}>Design Consultancy Services</Link></li>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/service/rental-services'}>Rental Services</Link></li>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/service/building-management'}>Building Management</Link></li>
                                </ul>
                            </div>
                        </Col>
                        <Col className={`fourth `}>

                            <div className={`menu__title-fourth ${hoveredColumnIndex === 3 ? 'column-hovered' : ''}`}>
                                <h4 className={'fourth-menu'}>Media Center</h4>
                                <ul>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/news-events?status=news'}>News</Link></li>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/news-events?status=events'}>Events</Link></li>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/news-events?status=blogs'}>Blogs</Link></li>
                                </ul>
                            </div>
                        </Col>
                        <Col className={`fifth `}>
                            <div className={`menu__title-fifth ${hoveredColumnIndex === 4 ? 'column-hovered' : ''}`}>
                                <h4 className={'fifth-menu'}>Navigation</h4>
                                <ul>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/career'}>Career</Link></li>
                                    <li onClick={handleCloseClick2}><Link prefetch={true} href={'/contact-us'}>Contact Us</Link></li>

                                </ul>
                            </div>
                        </Col>
                    </Row>

                    <Row className={'social menu-body'}>
                        <Col className={'menu__title-first'}>
                            <h4>
                                Address
                            </h4>
                            <ul>
                                <li>
                                    <Link href={'https://maps.app.goo.gl/vd5Q7KPCMBRtsbJY6'} target={'_blank'}>House 04, Road 28(Old) 15 (New), Dhanmondi, Dhaka 1209</Link>
                                </li>
                            </ul>
                        </Col>
                        <Col className={'menu__title-first'}>
                            <h4>
                                Call
                            </h4>
                            <ul>
                                <li>
                                    <Link href={'tel:+8802 41020276'}>+8802 41020276-8</Link>
                                </li>
                            </ul>
                        </Col>
                        <Col className={'menu__title-first'}>
                            <h4>
                                Email Us
                            </h4>
                            <ul>
                                <li>
                                    <Link href='mailto:info@ups-bd.com'>info@ups-bd.com</Link>
                                </li>
                            </ul>
                        </Col>
                        <Col className={'menu__title-first'}>
                        </Col>
                        <Col>
                            <div className={'social__icon'}>
                                <div className={'social__icon__icons'}>
                                    <div className={'social__icon__icons__facebook'}>
                                        <li><Link href={'https://www.facebook.com/unimasspropertysolutions/'} target="_blank">
                                            <SvgButton svg={fb}
                                                       borderColor={`${white}`}
                                                       width={30}
                                                       height={30}
                                            />
                                        </Link></li>



                                    </div>
                                </div>

                                <div className={'social__icon__icons'}>
                                    <div className={'social__icon__icons__twitter'}>
                                        <li >
                                            <Link href={'https://www.instagram.com/unimassbd121/'} target="_blank">
                                                <SvgButton svg={demo}
                                                           borderColor={`${white}`}
                                                           width={30}
                                                           height={30}
                                                />
                                            </Link></li>
                                    </div>
                                </div>

                                <div className={'social__icon__icons'}>
                                    <div className={'social__icon__icons__insta'}>
                                        <li >
                                            <Link href={'https://www.linkedin.com/company/unimass-holdings-limited/'} target="_blank">
                                                <SvgButton svg={ln}
                                                           borderColor={`${white}`}
                                                           width={30}
                                                           height={30}
                                                />
                                            </Link>
                                        </li>


                                    </div>
                                </div>

                                <div className={'social__icon__icons'}>
                                    <div className={'social__icon__icons__youtube linkedin'}>
                                        <li>
                                            <Link href={'https://www.youtube.com/@unimassholdingsltd7942'} target="_blank">
                                                <SvgButton svg={youtube}
                                                           borderColor={`${white}`}
                                                           width={30}
                                                           height={30}
                                                />
                                            </Link>
                                        </li>
                                    </div>
                                </div>

                                <div className={'social__icon__icons'}>
                                    <div className={'social__icon__icons__youtube'}>
                                        <li>
                                            <Link href={'https://twitter.com/unimass-holdings-limited'} target="_blank">
                                                <SvgButton svg={twitter}
                                                           borderColor={`${white}`}
                                                           width={30}
                                                           height={30}
                                                />
                                            </Link>
                                        </li>

                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </StyledPopup>

            <StyledDefaultMenu
                className={`${scrollDown ? 'scroll-down' : ''} ${scrollUp ? 'scroll-up' : ''} ${isProjectPage || isLandowner ? 'menu-v2' : ''} main-menu-desktop`} isProjectPage={isProjectPage} isLandowner={isLandowner}
            >
                <Container className={'desktop-default'}>
                    <Row>
                        <Col>
                            <div className={'header'}>
                                <div className="logo">
                                    <Link prefetch={true} href={'/'} className={'logo_normal'}>
                                        <img height={80} width={112} src={'/images/static/logo.svg'} alt={'Unimass Property Solution'}/>
                                    </Link>
                                    <Link prefetch={true} href={'/'} className={'logo_sticky'}>
                                        <img height={80} width={112} src={'/images/static/logo.svg'} alt={'Unimass Property Solution'}/>
                                    </Link>
                                </div>

                                <div className={'header__right__logo'}>
                                    <Link prefetch={true} href={'/project'}>
                                        Property
                                    </Link>
                                    {
                                        pathName === '/' ?

                                            <div onClick={() => handleScrollClick('#services')} onTouchStart={() => handleScrollClick('#services')}>
                                                <Link prefetch={true} href={'javascript:void(0)'}>
                                                    Services
                                                </Link>
                                            </div>
                                        :
                                            <Link prefetch={true} href={'/#services'}>
                                                Services
                                            </Link>
                                    }


                                    <Link prefetch={true} href={'/contact-us'}>
                                        Contact
                                    </Link>
                                    <Link prefetch={true} href={'/start-with-us'}>
                                        Begin Your Journey
                                    </Link>
                                    <Link prefetch={true} href={'https://unimassbd.com/'} target={'_blank'}>
                                       Unimass Holdings Ltd.
                                    </Link>
                                    <button onClick={handleMenuClick} >
                                        <SvgButton svg={isProjectPage || isLandowner ?menuIconB : menuIconW}
                                                   borderColor={isProjectPage || isLandowner? `#000` :`${white}`}
                                                   width={40}
                                                   height={40}
                                        />
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </StyledDefaultMenu>
        </>

    );
}


const StyledDefaultMenu = styled.section`
    background: ${props => props.isProjectPage || props.isLandowner ? `${white}` : ''};
    border-bottom: 1px solid ${props => props.isProjectPage ? `rgba(0, 0, 0, 0.4)` : 'rgba(255, 255, 255, 0.5)'};
    z-index: 50;
    @media (max-width: 991px) {
        display: none;
    }
    width: 100%;
    top: 0;
    left: 0;
    position: fixed;
    overflow: hidden;

    .logo_sticky {
        display: none;
    }

    &.menu-v2 {

        .logo_normal {
            display: none;
        }
    
        .logo_sticky {
            display: block;
        }
    }


    &.hover {
        svg {
            path {
                stroke: ${props => props.isProjectPage || props.isLandowner ? `#000` : ''} !important;
            }
        }
    }


    //hamburger-icon

    .hamburger-icon {
        display: inline-block;
        cursor: pointer;
        width: 30px;
        height: 16px;
        position: relative;
        margin: 3px 0px 0px 23px;
    }

    .hamburger-icon span {
        display: block;
        position: absolute;
        height: 2px;
        transition: transform 0.3s ${Transition};
        width: 65%;
        background: ${props => props.isProjectPage || props.isLandowner ? `#000` : `${white}`};


        &:nth-child(1) {
            top: 0;
            left: 35%;
            transition: width .3s ${Transition};
        }

        //

        &:nth-child(2) {
            right: 0;
            top: 50%;
            margin-top: -1px;
            transition: width .3s ${Transition};
        }

        &:nth-child(3) {
            bottom: 0;
            right: 0;
            transition: width .3s ${Transition};
        }

    }


    .header {
        display: flex;
        align-items: center;
        padding-top: 17px;
        padding-bottom: 17px;

        &__menu {
            display: flex;
            grid-template-columns: repeat(4, 1fr);

            li:first-child {
                padding-left: 58px;
            }

            li:not(:last-child) {
                margin-right: 30px;
            }

            li {
                display: flex;
                justify-content: center;

                a {
                    color: white;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 20px;

                    &:hover {
                        color: white !important;
                        opacity: 70%;
                    }

                    :active {
                        color: green;
                    }
                }
            }
        }

        &__right {
            margin-left: auto;

            li {
                a {
                    color: white;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 20px;
                }
            }

            &__logo {
                cursor: pointer;
                display: flex;
                margin-left: auto;
                align-items: center;

                a {
                    color: ${props => props.isProjectPage || props.isLandowner ? `#000` : `${white}`};
                    font-size: 12px;
                    line-height: 18px;
                    font-weight: 500;
                    margin-right: 30px;
                    transition: 0.7s all ${Transition};

                }

                button {
                    padding: 0;
                    display: flex;
                    background-color: unset;
                    border: unset;
                }

                p {
                    color: #FFFFFF;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 20px;
                }
            }
        }

        .active {
            a {
                opacity: 70%;;
            }
        }

        .header__right__logo {
            svg {
                //margin-left: 20px;

                &:hover {
                    #Line_3965 {
                        x1: 50;
                        transform: translate(0);
                    }

                    #Line_3966 {
                        x1: 20;
                        transform: translate(0, 8px);
                    }

                    #Line_3967 {
                        x1: 50;
                        transform: translate(16px);
                    }

                    g {
                        line {
                            stroke: #f9f9f9;
                        }
                    }
                }
            }
        }

`;
const StyledPopup = styled.section`

    //pop-up menu
    z-index: 100 !important;

    .menu-top-handle {
        opacity: 0;
    }

    visibility: hidden;


    &.show {
        visibility: visible;

        .menu-top-handle {
            //padding-top: 18px;
            display: block;
        }
    }

    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    padding-top: 12px;
    background-color: ${darkBrown};
    overflow: hidden;

    .first-image {
        position: absolute;
        background-size: cover;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        object-fit: unset;
        opacity: 0;
        transition: opacity 1s ${Transition};
    }

    .second-image {
        position: absolute;
        background-size: cover;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        object-fit: unset;
        opacity: 0;
        transition: opacity 1s ${Transition};
    }

    .third-image {
        position: absolute;
        background-size: cover;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        object-fit: unset;
        opacity: 0;
        transition: opacity 1s ${Transition};
    }

    .fourth-image {
        position: absolute;
        background-size: cover;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        object-fit: unset;
        opacity: 0;
        transition: opacity 1s ${Transition};
    }

    .fifth-image {
        position: absolute;
        background-size: cover;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        object-fit: unset;
        opacity: 0;
        transition: opacity 1s ${Transition};
    }

    .first-image.active {
        opacity: 1;
    }

    .second-image.active {
        opacity: 1;
    }

    .third-image.active {
        opacity: 1;
    }

    .fourth-image.active {
        opacity: 1;
    }

    .fifth-image.active {
        opacity: 1;
    }

    //.first:hover ~ .hover-image .first-image {
    //  display: block;
    //}
    //
    //.second:hover ~ .hover-image .second-image {
    //  display: block;
    //}
    //.third:hover ~ .hover-image .third-image {
    //  display: block;
    //}
    //.fourth:hover ~ .hover-image .third-image {
    //  display: block;
    //}


    .menu-extra {
        padding-top: 45px;
    }


    .menu-image {
        position: relative;

        &__first img {
            position: absolute;
            background-size: cover;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            object-fit: unset;
        }
    }

    .container {
        height: 100vh;
        position: relative;
        padding-top: 8px;
    }

    //.menu-body{
    //  display: grid;
    //  grid-template-columns: repeat(5, calc(20% - 30px));
    //  grid-column-gap: 30px;
    //  }


    .menu-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid rgba(233, 233, 233, 0.25);
        margin-bottom: 80px;

        &__right {
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;

            svg {
                transition: all 0.7s ${Transition};
            }

            svg:hover {
                cursor: pointer;
                transition: all 0.7s ${Transition};
                transform: rotate(90deg);
            }

            p {
                padding-right: 28px;
                font-size: 16px;
                color: white;
            }
        }
    }

    .menu {
        &__title-first, &__title-second, &__title-third, &__title-fourth, &__title-fifth {
            margin-bottom: 15px;

            h4 {
                color: #707070;
                font-size: 16px;
                font-weight: 400;
                line-height: 20px;
                margin-bottom: 15px;
                transition: color .5s ${Transition};
            }

            a {
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                margin-bottom: 10px;

                &:hover {
                    color: white !important;
                    opacity: 70%;
                }
            }

            ul {
                li {
                    a {
                        color: white;
                        display: flex;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 21px;
                        transition: color .5s ${Transition};
                    }
                }
            }

        }
    }

    .menu__title-fifth {
        a {
            cursor: pointer;
        }
    }

    .hovered {
        h4 {
            color: white;
            transition: color .5s ${Transition};
            opacity: 70%;
        }
    }

    .row-hovered {
        ul {
            li {
                a {
                    color: grey;
                    display: flex;
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 20px;
                    transition: color .5s ${Transition};
                }
            }
        }

        .column-hovered {
            ul {
                li {
                    a {
                        color: white;
                        display: flex;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 20px;
                        transition: color .5s ${Transition};
                    }
                }
            }
        }
    }


    .menu-body {

        .default-color {
            li {
                a {
                    color: white;
                    display: flex;
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 20px;
                    transition: color .5s ${Transition};
                }
            }
        }
    }

    .social {
        width: 100%;
        position: absolute;
        bottom: 40px;

        &__icon {
            display: flex;
            justify-content: flex-end;

            &__icons:not(:last-child) {
                padding-right: 20px;
            }

            &__icons {

            }
        }
    }

`;

export default React.memo(DesktopMenu);
